import {combineLatest} from 'rxjs';
import {map, filter} from 'rxjs/operators';
import {fiatAccountCache$} from './fiat-accounts-cache';
import {currenciesCurrencyCache$} from '@/config';
import {numUtil} from '@/helper/num';
import {calcValueBalanceUtils} from '@/helper/calc-value-balance';
import {indexPricesCache$} from '@/price-index/price-index';
import {fiat$} from '@/state/fiat';

const BTC_PRECISION = 8;
const USD_PRECISION = 2;

export const fiatAccounts$ = combineLatest([
  fiatAccountCache$,
  currenciesCurrencyCache$,
  indexPricesCache$,
  fiat$,
]).pipe(map(convertFiatAccount), filter(Boolean));

function convertFiatAccount([fiatAccountCache, currencies, indexPricesCache, fiatCurrency]) {
  const btcCurrency = currencies.get('BTC');
  if (!btcCurrency) {
    return null;
  }

  const usdCurrency = currencies.get('USD');
  const fiatAccount = fiatAccountCache.toArray();
  if (!usdCurrency) {
    return fiatAccount;
  }
  const {valueScale: btcValueScale, valueFactor: btcValueFactor} = btcCurrency;
  const {valueScale: usdValueScale, valueFactor: usdValueFactor} = usdCurrency;

  const btcIndexPrice = indexPricesCache.get('.BTC');
  if (!btcIndexPrice) {
    return null;
  }

  const usdtRate = indexPricesCache.get('.USDT');
  if (!usdtRate) {
    return null;
  }

  return fiatAccount.map(({currency, balanceEv}) => {
    const rate = indexPricesCache.get('.' + currency);
    const fiatRate = indexPricesCache.get('.' + fiatCurrency);
    const usdAmountEV = calcUsdEv(balanceEv, rate);
    const btcEv = calcValueBalanceUtils.getBalanceEv(
      usdAmountEV,
      btcIndexPrice.priceEp,
      usdValueFactor,
      btcIndexPrice.priceFactor,
      btcValueFactor
    );
    const usdtEv = calcValueBalanceUtils.getBalanceEv(
      usdAmountEV,
      usdtRate.priceEp,
      usdValueFactor,
      usdtRate.priceFactor,
      usdValueFactor
    );

    const usdBalance = numUtil.floor(usdAmountEV, USD_PRECISION, usdValueScale);

    return {
      currency,
      balanceEv,
      usdBalance: usdBalance,
      usd: usdBalance,
      money: calcMoney(usdAmountEV, fiatRate, USD_PRECISION, usdValueScale),
      btc: numUtil.floor(btcEv, BTC_PRECISION, btcValueScale),
      usdt: calcMoney(usdtEv, usdtRate, USD_PRECISION, usdValueScale),
    };
  });
}

function calcUsdEv(amountEv, rate) {
  if (rate) {
    return (amountEv * rate.priceEp) / 1e2;
  }
  return 0;
}

function calcMoney(usdEv, rate, precision, scale): string {
  if (rate) {
    const {priceEp, priceScale = 4} = rate;
    return numUtil.delimit(numUtil.floor(usdEv / priceEp, precision, scale - priceScale));
  }

  return (0).toFixed(precision);
}
